module.exports = __webpack_public_path__ + "static/gallery-img-2-a0b1ebe13183f5f05b179fcd5c5c6873.jpg";